// A list draws before its slideovers are on the page: shared/lazy_slideovers
// fetches the slideover shell in a second request, and on a slow dyno that can
// take seconds. An open-* event sent in that gap had no listener and vanished,
// so the row looked dead until a refresh.
//
// The loader keeps every shell still in flight in `window.lazySlideoversLoading`
// (a plain Set shared with its inline script, which may run before this module)
// and fires `lazy-slideovers:ready` each time one settles. While a shell on the
// page is still loading, any open-* event waits here and is sent as it was once
// the last shell is listening. Everything else goes straight through.

const OPENER = /^open-/

const loading = () => (window.lazySlideoversLoading ||= new Set())

const pending = () => {
  for (const container of loading()) {
    if (container.isConnected) return true
    loading().delete(container)
  }
  return false
}

let waiting = []

const send = (name, fire) => {
  if (OPENER.test(name) && pending()) waiting.push(fire)
  else fire()
}

const flush = () => {
  if (pending()) return
  const queued = waiting
  waiting = []
  queued.forEach((fire) => fire())
}

window.addEventListener('lazy-slideovers:ready', flush)
// A click queued on one page must not open something on the next.
document.addEventListener('turbo:before-visit', () => { waiting = [] })

export const lazySlideovers = {
  send,
  open: (name, detail = {}) => send(name, () => window.dispatchEvent(new CustomEvent(name, { detail }))),
}

window.lazySlideovers = lazySlideovers
